import React from 'react';
import '../../style.css';
import WebServer from '../../../functions/server';
import { Button, Grid, Popup } from 'semantic-ui-react';
import { zIndex } from 'material-ui/styles';

class View extends React.Component {

  viewPdf(closing_balance, openingbalance) {
    if (!this.props.menuPermission.exports) {
      alert('You Are Not Allow To Exports!!');
      return;
    }
    let open = WebServer() + "pdf/statementpdf.php?customerId="+this.props.id+"&from-date="+
    this.props.from_date+"&to-date="+this.props.to_date+'&closingBalance='+Number(closing_balance).toFixed(2)+
    '&openingbalance='+Number(openingbalance).toFixed(2);
    window.open(open);
  }

  makeDecimalPoint(value) {
    try {
      value = value.toFixed(2);
    } catch (e) {
      value = 0.00;
    }
    return value;
  }

  makeDecimalPoint1(value) {
    try {
      value = value.toFixed(2);
    } catch (e) {
      value = '';
    }
    return value;
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  calculation() {
    let data = this.props.data;
    let length = data.length;
    let value = this.convertIntoNumber(this.props.openingBalance);



    for (var i = length; i > 0; --i) {
      let amount = data[i - 1].amount;
      amount = Number(amount);
      if (amount > 0) {
        amount = amount * -1;
      }
      if (data[i - 1].type == 'Sales') {
          value = value + amount;
      }
      else if (data[i - 1].type == 'Purchase') {
        value = value - amount;
      }
      else if (data[i - 1].type == 'Transfer Out') {
        value = value + amount;
      }
      else if (data[i - 1].type == 'Transfer In') {
        value = value - amount;
      }
      else {
        if (data[i - 1].type == "Payment") {
          value = value + amount;
        }
        else {
          value = value - amount;
        }

      }
      data[i - 1].closing = value;
    }
    return data;
  }

  viewPdfs(type, id, voucherno) {
    let open = "";
    if (type == 'Invoice') {
      open = WebServer() + "pdf/placeorderpdf2.php?quotationId="+id+"&customerId="+this.props.id+"&bankId=0";
    }
    if (type == 'Receipt') {
      open = WebServer() + "pdf/receipt/receiptpdf.php?voucher="+voucherno+"&copy=1";
    }
    window.open(open);
  }

  render() {
    let limitation = 1;
    let i = 1;
    let data = this.calculation();
    
    let openingbalanceLast = this.convertIntoNumber(this.props.openingBalance);
    let closing_balance = 0;

    return (
      <div>
        <br/>
        <div style={{fontSize: 18, textAlign: 'right', paddingTop: '1%'}}>
          <b></b>
        </div>

        <table width='100%' id="table">
          <tr>
            <th id="th"><center>Voucher No</center></th>
            <th id="th"><center>Type</center></th>
            <th id="th"><center>Date</center></th>
            <th id="th"><center>Inwards</center></th>
            <th id="th"><center>Outwards</center></th>
            <th id="th"><center>Mode</center></th>
            <th id="th"><center>Remarks</center></th>
            <th id="th" style={{display: 'none'}}><center>Opening Balance</center></th>
            <th id="th"><center>Closing Balance</center></th>
            <th id="th"><center>Follow Up</center></th>
            <th id="th" style={{display: 'none'}}><center>Points</center></th>
          </tr>
          { data.map((z) => {
              let voucher = 'R'+z.id;
              let amount = z.amount;
              let inwards = '';
              let outwards = '';
              let closing = z.closing;
              closing = this.convertIntoNumber(closing);
              let type = z.type;
              amount = this.convertIntoNumber(amount);
              if (amount < 0) {
                amount = amount * -1;
              }

              
              if (type == 'Sales') {
                type = "Invoice";
                voucher = 'I'+z.quotation_no;
                inwards = '';
                outwards = amount;
              }
              else if (type == 'Purchase') {
                voucher = 'P'+z.quotation_no;
                inwards = amount;
                outwards = '';
              }

              else if (type == 'Transfer Out') {
                voucher = 'P'+z.quotation_no;
                inwards = '';
                outwards = amount;
              }
              else if (type == 'Transfer In') {
                voucher = 'P'+z.quotation_no;
                inwards = amount;
                outwards = '';
              }

              else if (type == '') {
                type = "UPI";
                voucher = 'P'+z.quotation_no;
                inwards = amount;
                outwards = '';
              }
              else {
                if (z.type == "Payment") {
                  voucher = 'P'+z.id;
                  inwards = '';
                  outwards = amount;
                }
                else {
                  voucher = 'RR'+z.id;
                  inwards = amount;
                  outwards = '';
                }
              }

              return (
                <tr>
                  <td style={{cursor: 'pointer'}} onClick={this.viewPdfs.bind(this, type, z.quotation_no, z.receipt_voucher)}><u style={{color: 'blue'}}>{z.receipt_voucher}</u></td>
                  <td><center>{type}</center></td>
                  <td><center>{z.timestamp.split(' ')[0]}</center></td>
                  <td>
                    <div style={{width: '100%', textAlign: 'right'}}>
                      {this.makeDecimalPoint1(inwards)}
                    </div>
                  </td>
                  <td>
                    <div style={{width: '100%', textAlign: 'right'}}>
                      {this.makeDecimalPoint1(outwards)}
                    </div>
                  </td>
                  <td>{z.mode}</td>
                  <td>{z.remarks}</td>

                  <td><div style={{textAlign: 'right'}}>Rs. {this.makeDecimalPoint(closing)}</div></td>
                  <td>{z.follower}</td>
                  <td style={{display: 'none'}}><center>{z.points}</center></td>
                </tr>
              )
            })
          }
        </table>



        <br/>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button onClick={this.viewPdf.bind(this, this.props.closingBalance, this.props.openingBalance)}>Download PDF</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <div style={{fontSize: 18, textAlign: 'right', paddingTop: '1%'}}>
              <b>{'OpeningBalance: ₹'+Number(this.props.openingBalance).toFixed(2)}</b>
            </div>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default View;
